module.exports = __webpack_public_path__ + "static/media/bibeo_deptrai.e954e5eb.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/bibeo_deptrai.jpg
 ** module id = 259
 ** module chunks = 0
 **/